import React, { useRef, useEffect } from "react";
import { MEDIA, mediaUrl } from "../config/media";
const C = { gold:"#C9A84C", goldLight:"#E8D5A0" };

export default function HeroBanner({ banner }) {
  const videoRef = useRef(null);
  const heroVideoSrc = mediaUrl(MEDIA.home.heroVideo) || "/videos/carnival-castle-hero.mp4";

  useEffect(() => {
    const video = videoRef.current;
    if (!video) return;

    const setStartTime = () => {
      if (video.currentTime < 1.5) {
        video.currentTime = 1.5;
      }
    };

    if (video.readyState >= 1) {
      setStartTime();
    } else {
      video.addEventListener("loadedmetadata", setStartTime, { once: true });
    }

    video.currentTime = 1.5;

    const handleTimeUpdate = () => {
      if (video.currentTime >= 41) {
        video.currentTime = 1.5;
        video.play().catch(() => {});
      }
    };

    video.addEventListener("timeupdate", handleTimeUpdate);
    return () => {
      video.removeEventListener("loadedmetadata", setStartTime);
      video.removeEventListener("timeupdate", handleTimeUpdate);
    };
  }, []);

  return (
    <>
      <section className="cc-hero">
        <video 
          ref={videoRef}
          src={`${heroVideoSrc}#t=1.5`}
          autoPlay 
          muted 
          loop 
          playsInline 
          className="cc-hero-vid"
          style={{ position: 'absolute', width: '100%', height: '100%', objectFit: 'cover', inset: 0, zIndex: 0 }}
          onError={(e) => {
            if (e.target.src !== "/videos/carnival-castle-hero.mp4#t=1.5") {
              e.target.src = "/videos/carnival-castle-hero.mp4#t=1.5";
            }
          }}
        />
        <div 
          className="cc-hero-ovl" 
          style={{ 
            zIndex: 2, 
            background: 'linear-gradient(to top, rgba(14,2,23,0.55) 0%, rgba(14,2,23,0.12) 18%, transparent 32%)',
            pointerEvents: 'none'
          }} 
        />
        <div className="cc-hero-cnt">
          <div className="cc-hero-text-wrap">
            <span className="cc-hero-eyebrow">
              PRIVATE THEATRE CELEBRATIONS
            </span>
            <p className="cc-hero-caption">
              Celebrate beautifully. Create unforgettable moments.
            </p>
          </div>

          <div className="cc-hero-cta-group">
            <a href="/locations" className="hero-cta-primary">🎉 Book Your Surprise</a>
            <a href="tel:8977917555" className="hero-cta-secondary">📞 Call to Book</a>
          </div>
        </div>

        <style>{`
          .cc-hero-cnt {
            position: absolute;
            bottom: 28px;
            left: 50%;
            transform: translateX(-50%);
            text-align: center;
            width: 90%;
            max-width: 480px;
            z-index: 3;
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 12px;
          }
          .cc-hero-text-wrap {
            display: flex;
            flex-direction: column;
            align-items: center;
            gap: 4px;
          }
          .cc-hero-eyebrow {
            font-size: 10px;
            letter-spacing: 2.5px;
            text-transform: uppercase;
            color: #E8D5A0;
            margin: 0;
            font-weight: 700;
            text-shadow: 0 1px 3px rgba(0,0,0,0.8), 0 2px 6px rgba(0,0,0,0.6);
            display: inline-block;
          }
          .cc-hero-caption {
            font-family: 'Playfair Display', Georgia, serif;
            font-style: italic;
            font-size: 13px;
            line-height: 1.4;
            margin: 0;
            color: rgba(255, 255, 255, 0.88);
            text-shadow: 0 1px 3px rgba(0,0,0,0.8), 0 2px 6px rgba(0,0,0,0.6);
            font-weight: 400;
          }
          .cc-hero-cta-group {
            display: flex;
            gap: 12px;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
          }
          .hero-cta-primary {
            background-color: #C9A84C;
            color: #1A0030;
            border: 1px solid #B89535;
            height: 44px;
            padding: 0 22px;
            border-radius: 50px;
            font-weight: 600;
            text-decoration: none;
            font-size: 12.5px;
            letter-spacing: 0.3px;
            transition: background-color 0.2s ease, transform 0.2s ease;
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          }
          .hero-cta-primary:hover {
            transform: translateY(-1px);
            background-color: #D4B65D;
            color: #1A0030;
          }
          .hero-cta-secondary {
            background-color: rgba(26, 0, 48, 0.55);
            color: #F8F5F0;
            height: 44px;
            padding: 0 20px;
            border-radius: 50px;
            font-weight: 600;
            text-decoration: none;
            font-size: 12.5px;
            letter-spacing: 0.3px;
            transition: background-color 0.2s ease, transform 0.2s ease, border-color 0.2s ease;
            border: 1px solid rgba(232, 213, 160, 0.45);
            backdrop-filter: blur(8px);
            -webkit-backdrop-filter: blur(8px);
            box-shadow: 0 3px 10px rgba(0, 0, 0, 0.3);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 6px;
          }
          .hero-cta-secondary:hover {
            background-color: rgba(94, 14, 115, 0.7);
            border-color: #C9A84C;
            transform: translateY(-1px);
            color: #FFFFFF;
          }
          @media (max-width: 768px) {
            .cc-hero-cnt {
              bottom: 18px;
              width: 92%;
              gap: 8px;
            }
            .cc-hero-eyebrow {
              font-size: 8.5px;
              letter-spacing: 2px;
            }
            .cc-hero-caption {
              font-size: 11.5px;
            }
            .hero-cta-primary, .hero-cta-secondary {
              height: 40px;
              padding: 0 16px;
              font-size: 11.5px;
            }
          }
          .cc-trust-chips-strip {
            background: #1A0030;
            padding: 16px 0;
            border-bottom: 1px solid rgba(255, 255, 255, 0.05);
            position: relative;
            z-index: 10;
          }
          .cc-trust-chips-inner {
            display: flex;
            justify-content: center;
            gap: 16px 36px;
            flex-wrap: wrap;
          }
          .cc-trust-chip-item {
            display: flex;
            align-items: center;
            gap: 10px;
            color: #fff;
          }
          .cc-trust-chip-icon {
            font-size: 20px;
            filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.5));
          }
          .cc-trust-chip-text {
            font-size: 13.5px;
            font-weight: 600;
            letter-spacing: 0.3px;
            color: #E8D5A0;
          }
          @media (max-width: 768px) {
            .cc-trust-chips-strip {
              padding: 12px 0;
            }
            .cc-trust-chips-inner {
              display: grid;
              grid-template-columns: 1fr 1fr;
              gap: 10px 14px;
              padding: 0 8px;
            }
            .cc-trust-chip-item {
              gap: 7px;
            }
            .cc-trust-chip-icon {
              font-size: 16px;
            }
            .cc-trust-chip-text {
              font-size: 11px;
              letter-spacing: 0.1px;
            }
          }
        `}</style>
      </section>

      {/* Trust Chips Strip */}
      <div className="cc-trust-chips-strip">
        <div className="container">
          <div className="cc-trust-chips-inner">
            {[
              { icon: "🏆", label: "Trained & Certified Staff" },
              { icon: "📱", label: "Easy Booking" },
              { icon: "💸", label: "Unbeatable Pricing" },
              { icon: "🔒", label: "Safe & Secure" },
            ].map((c, i) => (
              <div key={i} className="cc-trust-chip-item">
                <span className="cc-trust-chip-icon">{c.icon}</span>
                <span className="cc-trust-chip-text">{c.label}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
}